var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pcg-checkbox',{staticStyle:{"line-height":"3rem"},attrs:{"value":_vm.checkSubItems()},on:{"input":_vm.selectCheckbox}})}
var staticRenderFns = []

export { render, staticRenderFns }